module.exports = __webpack_public_path__ + "static/media/guitars.37c15af8.svg";